





































































































































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import Requester from '../../requester';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { ConsultaColetiva } from '../../../../back/src/entity/ConsultaColetiva';
import { Consulta } from '../../../../back/src/entity/Consulta';
import { ConsultaColetivaIniciarFormData, ConsultaColetivaFinalizarFormData } from '../../../../back/src/types';

import ConsultaColetivaAddPacienteDialog from '../../components/consultas_coletivas/ConsultaColetivaAddPacienteDialog.vue';
import ConsultaColetivaObservacoesDialog from '../../components/consultas_coletivas/ConsultaColetivaObservacoesDialog.vue';
import PacienteConsultaColetivaCard from '../../components/pacientes/PacienteConsultaColetivaCard.vue';
import CustomDialog from '../../components/CustomDialog.vue';
import ConsultaForm from '../../components/consultas/ConsultaForm.vue';
import Confirmar from '../../components/Confirmar.vue';
import ThePacientesResumo from '../../components/pacientes/ThePacientesResumo.vue';
import ThePacientesObservacoesAlert from '../../components/pacientes/ThePacientesObservacoesAlert.vue';

export default Vue.extend({
  name: 'ConsultaColetivaAtiva',
  components: {
    ConsultaColetivaAddPacienteDialog,
    ConsultaColetivaObservacoesDialog,
    PacienteConsultaColetivaCard,
    CustomDialog,
    ConsultaForm,
    Confirmar,
    ThePacientesResumo,
    ThePacientesObservacoesAlert,
  },
  data() {
    return {
      loading: true,
      dialogResumoPaciente: false,
      dialogConfirmaInicio: false,
      dialogConsulta: false,
      consultaColetiva: Object as () => ConsultaColetiva,
      consultas: Object as () => Consulta[],
      consultaSelecionada: Object as () => Consulta,
      pacienteSelecionada: null,
    };
  },
  computed: {
    consultaColetivaId(): number {
      return this.$route.params.consultaColetivaId as number;
    },
    dataInicio() {
      return moment(this.consultaColetiva.datetime_agendamento).format('DD/MM/YYYY');
    },
    dataFim() {
      return moment(this.consultaColetiva.datetime_agendamento_fim).format('DD/MM/YYYY');
    },
    horaInicio() {
      return moment(this.consultaColetiva.datetime_agendamento).format('HH:mm');
    },
    horaFim() {
      return moment(this.consultaColetiva.datetime_agendamento_fim).format('HH:mm');
    },
    inicioFimMesmoDia() {
      return this.dataInicio === this.dataFim;
    },
    nomePacienteSelecionada() {
      return (this.consultaSelecionada && this.consultaSelecionada.paciente)
        ? this.consultaSelecionada.paciente.nome : '';
    },
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    pacientes() {
      return _.map(this.consultaColetiva.consultas, consulta => consulta.paciente);
    },
    pacientesPresentes() {
      return _.filter(this.consultas, consulta => consulta.presenca_consulta_coletiva === true)
        .length;
    },
  },
  mounted() {
    this.getConsultaColetiva();
  },
  methods: {
    closeDialogConsulta() {
      this.dialogConsulta = false;
    },
    openDialogConsulta(consulta) {
      this.consultaSelecionada = consulta;
      this.dialogConsulta = true;
    },
    async getConsultaColetiva() {
      this.loading = true;
      try {
        const response = await Requester.consultaColetiva.consultaColetiva(
          this.consultaColetivaId,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.consultaColetiva = response.data;
          this.consultas = response.data.consultas;
          this.promptConfirmaInicio();
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    async atualizaConsulta(consultaId: number) {
      try {
        const response = await Requester.consulta.consulta(consultaId);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          const consulta = response.data;
          const index = _.findIndex(this.consultaColetiva.consultas, { id: consulta.id });
          this.consultaColetiva.consultas.splice(index, 1, consulta);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      }
    },
    async iniciaConsulta() {
      this.loading = true;
      const formData: ConsultaColetivaIniciarFormData = {
        id: this.consultaColetiva.id,
      };
      try {
        const response = await Requester.consultaColetiva.iniciaConsultaColetiva(
          formData,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.dialogConfirmaInicio = false;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    async finalizaConsultaColetiva() {
      if (await this.confirmar.open(
        'Finalizar consulta coletiva?',
        'Tem certeza que deseja finalizar esta consulta coletiva?',
      ) === false) {
        return;
      }
      try {
        const response = await Requester.consultaColetiva.finalizaConsultaColetiva(
          {
            id: this.consultaColetiva.id,
          } as ConsultaColetivaFinalizarFormData,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', {
            color: 'success',
            text: 'Consulta coletiva finalizada com sucesso.',
          });
          this.$router.push({ name: 'ConsultasColetivasIndex' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      }
    },
    promptConfirmaInicio() {
      if (this.consultaColetiva.started == null) {
        this.dialogConfirmaInicio = true;
      }
    },
    exibeResumoPaciente(paciente: Paciente) {
      this.pacienteSelecionada = paciente;
      this.dialogResumoPaciente = true;
    },
  },
});
